
import React, { Component } from "react";
// import Dashboard from "../components/dynamicDashboard/Dashboard";
import Window from "../components/dynamicDashboard/Window";
import { v4 as uuidv4 } from "uuid";
import Tower from "../components/Tower";
import { getAnonymousToken, getToken, getUserInfo, initUser, translate } from "../utils/useful";
import Loader from "react-loader-spinner";
import html2canvas from "html2canvas";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as actions from "../stores/actionsList";
import MobileBottomBar from "../components/MobileBottomBar";
import WindowShots from "../components/dynamicDashboard/WindowShots";
import DashboardsContainer from "../components/dynamicDashboard/DashboardsContainer";
import TabFolder from "./TabFolder";
import { init } from "../utils/init.services";
import IncomingVideoCall from "../components/widgets2/IncomingVideoCall";
import IncomingVoiceCall from "../components/widgets2/IncomingVoiceCall";
import WaitingCall from "../components/widgets2/WaitingCall";
import store from "../stores/storeConfig";
import i18n from 'i18next';
import { languagesInfo } from "../variables/config";
import SkeletonDashboardsContainer from "../components/dynamicDashboard/SkeletonDashboardsContainer";
import Cookies from "universal-cookie";
import ButtonAnimated from "../components/buttons/ButtonAnimated";
import socketServices from "../utils/socket.services";


class Desktop extends Component {
  state = {
    dashboardPos: 410,
    windows: {},
    screenshotCount: 0,
    showWindowsShots: false,
    tabFolder: false,
    minimize: false,
    minimizedWindows: [],
    colors: {
      primaryColor: '#410c86',
      secondaryColor: '#631bcf',
      textColor: '#fff'
    },
  };

  componentDidMount() {

    // this.addNewWindow('CreateHub')
    let path = window.location.pathname.split("/").filter((value) => value != '')
    // console.log('path', path);
    if (path.length > 0) {
      this.checkUserNoAuth();
      this.checkURL(true, path);

    } else {
      this.checkUser();
      // setTimeout(() => {

      this.checkURL(true, path);
      // }, 2000);



    }
    this.setState({
      appSize: {
        appWidth: window.innerWidth,
        appHeight: window.innerHeight,
      },
      isDesktop: window.innerWidth > 520 ? true : false,
      isMobile: window.innerWidth > 520 ? false : true,
    });
    // console.log(window.innerWidth > 520 ? true : false);
    window.addEventListener("resize", () => this.resizeApp);
    this.appRef.addEventListener("wheel", this.mouseWheel);


    const cookies = new Cookies();
    let token = cookies.get('token');
    if (token) {
      // this.setState({ isLoading: true })
      this.waitForId(10)
    } else {
      this.setState({ notLoggedIn: true })
    }

  }

  componentWillUnmount() {
    this.appRef && this.appRef.removeEventListener("wheel", this.mouseWheel);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.user?.loggedin != prevProps.user?.loggedin
      //  &&
      // this.props.user?.loggedin


    ) {

      this.setState({ notLoggedIn: !this.props.user?.loggedin })

      setTimeout(() => {
        // console.log('hereeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeedidu', prevProps);
        this.checkURL(true);
      }, 2500);
    }
  }



  waitForId = (leftAttempt) => {
    if (this.props.user?.info?._id) {

      this.setState({ notLoggedIn: false })
    } else {
      setTimeout(() => {
        if (leftAttempt != 0) {
          this.waitForId(leftAttempt - 1)
        } else {
          this.setState({ notLoggedIn: true })
        }
      }, 500);
    }
  }

  setStateProps = (key, value) => {
    this.setState({ [key]: value });

    // console.log("set view", key, value);
  };
  checkURL = (force, pathArray) => {
    // console.log('hereeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee');
    let path = window.location.pathname + window.location.search;

    // console.log('hereeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee', path);
    let windows = JSON.parse(JSON.stringify(this.props.user.windows));

    // console.log('herrerererererer2');
    if (windows && Object.values(windows).length > 0) {
      // console.log('herrerererererer3' , windows);
      //

      let lastSelected = {}
      this.setState({ prevLoc: path });
      // for (let i = 0; i < Object.values(windows).length; i++) {
      //   const element = Object.values(windows)[i];
      //   // console.log(element)
      //   this.reopenWindows(element.id, element.type, element.data, element.defaultPosition, element)
      //   if (element.lastSelected == true) {
      //     lastSelected = element
      //   }
      // }
    }
    // let newWindows = Object.values(windows).filter((value) => !value?.minimized).filter((value) => !value?.data.path.includes('authentication'))
    // if (newWindows.length > 0) {
    //   if (Object.keys(lastSelected).length > 0) {
    //     this.changeIndex(lastSelected.id)

    //   } else {

    //     this.changeIndex(newWindows[newWindows.length - 1].id)
    //   }
    // }
    //  else {

    let newPath = window.location.pathname.split("/").filter((value) => value != '')
    // console.log('hereeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeepath', newPath.length);
    if ((path != this.state.prevLoc || force) && newPath.length > 0) {
      //
      this.setState({ prevLoc: path });
      this.urlToWindow(window.location, windows, pathArray);
    }
    // }
  };

  urlToWindow = (location, windows, pathArray) => {
    // console.log('hereeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeaddtow', location);
    if (pathArray?.includes("Authentication")) {
      return;
    }
    setTimeout(() => {
      if (this.props.user?.loggedin || true) {
        let path = []; // location.pathname ? location.pathname.split('/') : []
        let page;
        let params = {};

        let search = location.search;
        let rawparams = new URLSearchParams(search);

        for (const [key, value] of rawparams.entries()) {
          params[key] = value;
        }

        location.pathname.split("/").forEach((element) => {
          if (element != "") {
            path.push(element);
          }
        });

        let type = path[0];

        let reserveds = [
          "downloader",
          "player",
          "payment",
          "rooms",
          "test",
          "email",
          "drive",
          "authentication",
          "login",
          "signup",
          "messenger",
          "forms",
          "desk",
          "social",
          "note",
          "notebook",
          "createhub",
          "createapplet",
          "search",
          "settings",
          "dashboardbuilder",
          "developers",
        ];

        // console.log(type);
        //
        //
        // console.log("path is 34", path)
        //
        if (type && reserveds.includes(type.toLowerCase())) {
          page = { type, path, params };
        }

        if (type == "a") {
          page = { type: "applet", path, params };
        }

        if (type == "h") {
          page = { type: "hub", path, params };
        }

        if (type == "r") {
          page = { type: "room", path, params };
        }

        if (!page && type) {
          page = { type: "hub", path, params };
        }
        let id = []
        if (page) {

          for (let i = 0; i < Object.values(windows).filter((value) => !value?.minimized).length; i++) {
            const element = Object.values(windows).filter((value) => !value?.minimized)[i];
            // console.log('passsgeeeeeee',JSON.stringify(element.type) , JSON.stringify(page.type),JSON.stringify(element.type) == JSON.stringify(page.type));
            // console.log('passsgeeeeeee',JSON.stringify(element.data.path), JSON.stringify(page.path),JSON.stringify(element.data.path) == JSON.stringify(page.path));
            // console.log('passsgeeeeeee',JSON.stringify(element.data.params), JSON.stringify(page.params), JSON.stringify(element.data.params) == JSON.stringify(page.params));
            if (!element.data.params) {
              element.data.params = {}
            }
            if (JSON.stringify(element.data.path) == JSON.stringify(page.path) && JSON.stringify(element.data.params) == JSON.stringify(page.params)) {
              // console.log('passsgeeeeeee',element);
              id.push(element)
            }
          }
          if (id.length > 0) {
            let pIndex = 0
            for (let i = 0; i < id.length; i++) {
              const element = id[i];
              if (element.lastSelected) {
                pIndex = i
              }

            }
            // console.log("authentication", pIndex, id);
            this.changeIndex(id[pIndex], windows);

          } else {
            for (let i = 0; i < Object.values(windows).filter((value) => value?.minimized).length; i++) {
              const element = Object.values(windows).filter((value) => value?.minimized)[i];
              // console.log('passsgeeeeeee',JSON.stringify(element.type) , JSON.stringify(page.type));
              // console.log('passsgeeeeeee',element.data.path, page.path);
              // console.log('passsgeeeeeee',element.data.params, page.params);
              if (!element.data.params) {
                element.data.params = {}
              }
              if (JSON.stringify(element.type) == JSON.stringify(page.type) && JSON.stringify(element.data.path) == JSON.stringify(page.path) && JSON.stringify(element.data.params) == JSON.stringify(page.params)) {
                // console.log('passsgeeeeeee',element);
                id.push(element.id)
                element.minimized = false
                break
              }
            }
            if (id.length > 0) {
              this.changeIndex(id[0], windows);

            } else {
              this.addNewWindow(page.type, page, "center");

            }

          }

          // console.log('passsgeeeeeee',id);


        }
      }
    }, 50);
  };

  checkUserNoAuth = (dontShowNotif) => {
    // console.log('hereeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeecheck');

    // this.props.actions.setUser({ info: { _id: "test" } }, null, true);

    // return;
    setTimeout(() => {
      if (getAnonymousToken()) {
        getUserInfo((data, err, status) => {
          if (data) {
            if (data.authorized) {
              this.props.actions.setAnonymousUser(data.user, null, true);
              setTimeout(() => {
                // initUser();
                socketServices.initSocket()
                // this.checkURL();
              }, 200);
            }
          }
        })
      }
      if (getToken()) {
        this.setState({ isLoadingUserInfo: true });

        getUserInfo((data, err, status) => {
          //
          //
          //

          this.setState({ isLoadingUserInfo: false });

          if (status === 401) {
            // console.log('40111111111');
            // setTimeout(() => {

            this.props.actions.forceLogoutUser();
            // }, 10);
            // setTimeout(() => {

            // this.addNewWindow("authentication", {}, "center");
            // }, 20);
          }
          if (data) {
            if (data.authorized) {
              this.props.actions.setUser(data.user, null, true);
              setTimeout(() => {
                // initUser();
                init()
                // this.checkURL();
              }, 200);
            } else {
              // console.log('40111111111nodata');
              // this.changeWindow('authentication', { path: ['authentication'] })
              // setTimeout(() => {

              this.props.actions.forceLogoutUser();
              // }, 10);
              // setTimeout(() => {

              // this.addNewWindow("authentication", {}, "center");
              // }, 20);
            }
          }

          if (err) {
            // console.log('tpq2');

            if (!dontShowNotif) {
              this.props.actions.addNotif({
                type: "error",
                title: "{{lang}}errors.cantConnectToServer",
                description: "{{lang}}errors.checkYourInternetConnection",
              });
            }
            this.props.actions.setUser({}, null, true);
            setTimeout(() => {
              // this.checkUser(true);
            }, 10000);
          }
        });

      } else {
        console.log('40111111111token');

        // setTimeout(() => {

        this.props.actions.forceLogoutUser();
        // }, 10);
        // setTimeout(() => {

        // this.addNewWindow("authentication", {}, "center");
        // }, 20);
      }
    }, 100);
  };


  checkUser = (dontShowNotif) => {
    // this.props.actions.setUser({ info: { _id: "test" } }, null, true);
    console.log("checkUser")
    // return;
    setTimeout(() => {
      if (getToken()) {
        this.setState({ isLoadingUserInfo: true });

        getUserInfo((data, err, status) => {
          //
          //
          //

          this.setState({ isLoadingUserInfo: false });

          if (status === 401) {
            console.log('40111111111');
            // setTimeout(() => {

            this.props.actions.forceLogoutUser();
            // }, 10);
            // setTimeout(() => {

            this.addNewWindow("authentication", {}, "center");
            // }, 20);
          }
          if (data) {
            if (data.authorized) {
              this.props.actions.setUser(data.user, null, true);
              setTimeout(() => {
                // initUser();
                init()
                // this.checkURL();
              }, 200);
            } else {
              console.log('40111111111nodata');
              // this.changeWindow('authentication', { path: ['authentication'] })
              // setTimeout(() => {

              this.props.actions.forceLogoutUser();
              // }, 10);
              // setTimeout(() => {

              this.addNewWindow("authentication", {}, "center");
              // }, 20);
            }
          }

          if (err) {
            // console.log('tpq');
            if (!dontShowNotif) {
              this.props.actions.addNotif({
                type: "error",
                title: "{{lang}}errors.cantConnectToServer",
                description: "{{lang}}errors.checkYourInternetConnection",
              });
            }
            this.props.actions.setUser({}, null, true);
            setTimeout(() => {
              // this.checkUser(true);
            }, 10000);
          }
        });
      } else {
        console.log('40111111111token');

        // setTimeout(() => {

        this.props.actions.forceLogoutUser();
        // }, 10);
        // setTimeout(() => {

        this.addNewWindow("authentication", {}, "center");
        // }, 20);
      }
    }, 100);
  };

  mouseWheel = (e) => {
    let scrollTop = this.dashboardsContainer?.main?.scrollTop;
    if (this.state.dashboardPos > 55) {
      if (Math.sign(e.wheelDelta) == -1) {
        // console.log("TP 55")
        let newPos = this.state.dashboardPos + e.wheelDelta / 2;
        if (newPos <= 55) {
          newPos = 55;
        }
        this.setState({
          dashboardPos: newPos,
        });
      }
      if (this.state.canScroll && scrollTop == 0) {
        console.log("make false");
        this.setState({ canScroll: false });
      }
    } else {
      if (!this.state.canScroll) {
        this.setState({ canScroll: true });
      }
      // console.log("IS ON TOP")
    }
    if (this.state.dashboardPos <= 400) {
      if (Math.sign(e.wheelDelta) == 1 && scrollTop == 0) {
        // console.log("TP 400")
        let newPos = this.state.dashboardPos + e.wheelDelta / 2;
        if (newPos > 400) {
          newPos = 400;
        }
        this.setState({
          dashboardPos: newPos,
        });
      }
    }
    // console.log(this.dashboardsContainer?.main?.scrollTop)
    e.stopPropagation();
    //
  };

  reopenWindows = (id, type, data, position, window) => {
    // console.log('hereeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeereopen', type);
    // if (this.props.user.loggedin || type.toLowerCase() == "authentication") {
    // if (type.toLowerCase() == "authentication") {
    //   return;
    // }
    // console.log('hereeeeeeeeeee22222');
    let defaultPosition = {};
    let width = window.width;
    let height = window.height;
    // let centerWidth = (window.innerWidth - width) / 2;
    if (this.props.settings?.language == "fa") {
      let centerWidth = -((window.innerWidth - width) / 2);
      if (position) {
        defaultPosition = position
      }
      else {
        defaultPosition = {
          x: centerWidth,
          y: (window.innerHeight - height) / 2,
        };

      }
      // console.log('centerWidth', centerWidth)
      if (!data) {
        data = {};
      }
      data.type = type;

      // console.log(window.info)
      // console.log(window.buttons)

      let newWindow = {
        type,
        id,
        defaultPosition,
        width,
        height,
        zIndex: window.zIndex ?? 13,
        type: type,
        data: data,
        minimized: window.minimized ?? false,
        befforeFullSc: window.befforeFullSc ?? {},
        canMaximize: window.canMaximize ?? true,
        canClose: window.canClose ?? true,
        canMinimize: window.canMinimize ?? false,
        disabled: window.disabled ?? false,
        lastSelected: window.lastSelected ?? false,
        info: window.info ?? {},
        buttons: window.buttons ?? {},
      };


      let windows = JSON.parse(JSON.stringify(this.props.user.windows));
      windows[id] = newWindow;
      // console.log(windows)

      // console.log("TP1")

      this.props.actions.changeWindow(windows)
      // this.setState({ windows });
      // if (type.toLowerCase() != "authentication") {
      //   this.updateURL(windows[id].data);
      // }
    }
    if (this.props.settings?.language == "en") {
      let centerWidth = ((window.innerWidth - width) / 2);
      if (position) {
        defaultPosition = position
      }
      else {
        defaultPosition = {
          x: centerWidth,
          y: (window.innerHeight - height) / 2,
        };

      }
      // console.log('centerWidth', centerWidth)
      if (!data) {
        data = {};
      }
      data.type = type;

      let newWindow = {
        type,
        id,
        defaultPosition,
        width,
        height,
        zIndex: window.zIndex ?? 13,
        type: type,
        data: data,
        minimized: window.minimized ?? false,
        befforeFullSc: window.befforeFullSc ?? {},
        canMaximize: window.canMaximize ?? true,
        canClose: window.canClose ?? true,
        canMinimize: window.canMinimize ?? false,
        disabled: window.disabled ?? false,
        lastSelected: window.lastSelected ?? false,
        info: window.info ?? {},
        buttons: window.buttons ?? {},


      };
      let windows = JSON.parse(JSON.stringify(this.props.user.windows));
      windows[id] = newWindow;
      // console.log('here2windows',windows,height,width,newWindow)
      // console.log("TP2")

      this.props.actions.changeWindow(windows)
      // this.setState({ windows });
      // if (type.toLowerCase() != "authentication") {
      //   this.updateURL(windows[id].data);
      // }
    }


    // }
  };
  addNewWindow = (type, data, position) => {
    // console.log('hereeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeadd', type, data, position);
    // if (this.props.user.loggedin || type.toLowerCase() == "authentication") {
    // if ((this.props.user.loggedin && type.toLowerCase() == "authentication") || type == "authentication") {
    if ((this.props.user.loggedin && type.toLowerCase() == "authentication")) {

      return;
    }

    // console.log("HERE")
    if (type.toLowerCase() == "authentication") {

      let pervWindows = JSON.parse(JSON.stringify(this.props.user.windows))
      if (Object.values(pervWindows).filter((value) => value?.type.toLowerCase() == "authentication").length > 0) {

        Object.values(pervWindows).forEach(element => {
          if (element.type == 'authentication') {
            this.changeIndex(element.id)

          }
        });
        return;
      }
    }

    // console.log('hereeeeeeeeeee22222', window.innerWidth, window.innerHeight);
    let defaultPosition = {};
    let width = 800;
    let height = 480;
    if (window.innerWidth <= 800 && window.innerHeight <= 480) {
      width = (window.innerWidth / 3) * 2
      height = (window.innerHeight / 3) * 2
    }
    // let centerWidth = (window.innerWidth - width) / 2;
    if (this.props.settings?.language == "fa") {
      let centerWidth = -((window.innerWidth - width) / 2);
      if (position == "center") {
        defaultPosition = {
          x: centerWidth,
          y: (window.innerHeight - height) / 2,
        };
      }
      else {
        defaultPosition = {
          x: -(Math.floor(Math.random() * ((window.innerWidth / 4) + 100))),
          y: Math.floor(Math.random() * (window.innerHeight / 4)),
        };
        // defaultPosition = {
        //   x: centerWidth,
        //   y: (window.innerHeight - height) / 2,
        // };
      }
      // console.log('centerWidth', centerWidth)
      let id = uuidv4();
      if (!data) {
        data = {};
      }
      data.type = type;
      if (!data.path) {
        let path = []
        path.push(type.toLowerCase())
        data.path = path
      }


      let newWindow = {
        type,
        id,
        defaultPosition,
        width,
        height,
        zIndex: 14,
        type: type,
        data: data,
      };
      if (type.toLowerCase() != "authentication") {
        newWindow.canMaximize = true
        newWindow.canMinimize = true
        newWindow.canClose = true
      } else {
        newWindow.canMaximize = true
        newWindow.canMinimize = true
        newWindow.canClose = false
      }
      let windows = JSON.parse(JSON.stringify(this.props.user.windows));
      windows[id] = newWindow;
      // console.log('herewindows',windows,width,height)

      // this.props.actions.changeWindow("TP!")
      // this.setState({ windows });
      if (type.toLowerCase() == "authentication") {
        this.props.actions.changeWindow(windows)
        this.updateURL({ path: ["authentication"] });

      }
      if (type.toLowerCase() != "authentication") {
        this.changeIndex(windows[id].id, windows);
      }
    }
    if (this.props.settings?.language == "en") {
      let centerWidth = ((window.innerWidth - width) / 2);
      if (position == "center") {
        defaultPosition = {
          x: centerWidth,
          y: (window.innerHeight - height) / 2,
        };
      }
      else {
        defaultPosition = {
          x: Math.floor(Math.random() * ((window.innerWidth / 4) + 100)),
          y: Math.floor(Math.random() * (window.innerHeight / 4)),
        };
      }
      // console.log('centerWidth', centerWidth)
      let id = uuidv4();
      if (!data) {
        data = {};
      }
      data.type = type;
      if (!data.path) {
        let path = []
        path.push(type)
        data.path = path
      }

      let newWindow = {
        type,
        id,
        defaultPosition,
        width,
        height,
        zIndex: 14,
        type: type,
        data: data,
      };
      if (type.toLowerCase() != "authentication") {
        newWindow.canMaximize = true
        newWindow.canMinimize = true
        newWindow.canClose = true
      } else {
        newWindow.canMaximize = true
        newWindow.canMinimize = true
        newWindow.canClose = false
      }
      let windows = JSON.parse(JSON.stringify(this.props.user.windows));
      // console.log('herewindow2s',newWindow)
      windows[id] = newWindow;
      // { console.log('aaaaaaaaaaaa', newWindow) }
      // console.log(windows)
      // console.log('herewindows',windows,width,height,newWindow)

      if (type.toLowerCase() == "authentication") {
        this.updateURL({ path: ["authentication"] });

        this.props.actions.changeWindow(windows)
      }
      // this.setState({ windows });
      if (type.toLowerCase() != "authentication") {
        this.changeIndex(windows[id].id, windows);
      }
    }


    // }
  };
  minimizeWindow = (id) => {
    // console.log('idddddd', id);
    let windows = JSON.parse(JSON.stringify(this.props.user.windows));
    windows[id].minimized = true;

    // console.log('idddddd', windows);
    let availableWindows = Object.values(windows).filter((value) => !value?.minimized)
    // console.log('idddddd', availableWindows);
    if (availableWindows.length > 0) {
      // this.props.actions.changeWindow(windows)
      setTimeout(() => {

        // this.changeWindow(availableWindows[availableWindows.length - 1].id, availableWindows[availableWindows.length - 1].type, availableWindows[availableWindows.length - 1].data, windows)
        this.changeIndex(availableWindows[availableWindows.length - 1].id, windows)
      }, 100);

    } else {

      // console.log("ghghxsfsfshtdj----id", windows);
      setTimeout(() => {

        this.changeIndex(null, windows)
        // this.changeWindow('hub', { path: [] })
      }, 100);

    }
    // this.setState({
    //   //  windows,
    //   tabFolder: true
    // });
  };

  minimizeAllWindow = () => {
    let windows = JSON.parse(JSON.stringify(this.props.user.windows));
    // console.log("windows 11", windows);
    Object.values(windows).map((window) => {
      window.minimized = true;
    });
    this.props.actions.changeWindow(windows)

    this.setState({ showWindowsShots: !this.state.showWindowsShots });
    // this.setState({windows})
  };

  closeWindow = (id) => {
    // console.log(id, "ghghxsfsfshtdj----id");
    let windows = JSON.parse(JSON.stringify(this.props.user.windows));
    delete windows[id];

    // console.log('qwerewewewews', windows)

    this.props.actions.changeWindow(windows)
    // this.setState({ windows }, () => {
    // console.log("ghghxsfsfshtdj--1111--id", this.props.user.windows);
    let newWindows = Object.values(windows).filter((value) => !value?.minimized)
    if (newWindows.length > 0) {
      setTimeout(() => {

        this.changeIndex(newWindows[newWindows.length - 1].id, windows)
      }, 100);

    } else {

      // console.log("ghghxsfsfshtdj----id", windows);
      setTimeout(() => {

        this.changeIndex(null, windows)
      }, 100);

    }

    // });
  };

  setWindowInfo = (id, info) => {
    // console.log('setWindowInfo', id, info);
    let windows = JSON.parse(JSON.stringify(this.props.user.windows));
    let window = windows[id];

    let newData = window.info;
    if (!newData) {
      newData = {};
    }
    // console.log('setWindowInfo', newData);
    for (const [key, value] of Object.entries(info)) {
      newData[key] = value;
    }
    windows[id].info = newData;
    // return

    this.props.actions.changeWindow(windows)
    // this.setState({ windows });
    // console.log('windowwwww', windows)
  };



  setWindowButtons = (id, info) => {
    let windows = JSON.parse(JSON.stringify(this.props.user.windows))
    // let window = windows[id]

    windows[id].buttons = info ? JSON.parse(JSON.stringify(info)) : []

    // console.log("setWindowButtons", id, info)
    // console.log("windows[id]", windows[id])

    this.props.actions.changeWindow(windows)
    // this.setState({ windows })

  }




  changeWindow = (id, type, data, pervWindows) => {


    // console.log("changeWindow", id, type, data, pervWindows)

    // console.log('iddddddddddddddd', id, type, data);
    let windows = pervWindows ?? {}
    if (!pervWindows) {

      // console.log('dataahereeeeeee222eaaahereeeeeeeeeee', windows);
      windows = JSON.parse(JSON.stringify(this.props.user.windows));
    }
    // console.log('dataahereeeeeee222eaaahereeeeeeeee22222222222222ee', windows);
    if (data) {

      // console.log('dataahereeeeeee222eaaa', data);
      // console.log('dataahereeeeeee222333eaaa', id);
      if (windows[id]) {
        // { console.log('hereeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeaddcha1') }
        if (!windows[id].history) {
          // { console.log('hereeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeaddcha2') }
          windows[id].history = [];
        }


        let currentWindow = windows[id];
        windows[id].history.push({
          type: currentWindow.type,
          data: currentWindow.data,
        });

        // console.log("changeWindow",data)

        windows[id].type = type;
        windows[id].data = data;
        windows[id].info = windows[id]?.info ?? {};

        // { console.log('hereeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeaddcha3', windows[id]) }

        // console.log('windows[id].data', windows[id].data);
        // this.setState({ windows });
        // return

        setTimeout(() => {

          // console.log('dataahereeeeeeeeaaa', data);
          this.props.actions.changeWindow(windows)
          this.updateURL(windows[id].data);
        }, 80);
      }

    } else {
      // console.log('dataahereeeeeeeeaaa', type);
      setTimeout(() => {

        this.props.actions.changeWindow(windows)
        this.updateURL(type);
      }, 80);
      // console.log('windowwwww', windows[id].info)
    }
  };

  updateURL = (data) => {
    // console.log('hereeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeaddup', data);
    let path = "";
    if (data?.path) {
      data.path.forEach((element) => {
        path = path + "/" + element;
      });
    } else {
      path = data?.type;
    }

    if (path == "" || path == null) {
      path = "/";
    }
    //



    if (data?.params && Object.keys(data.params).length > 0) {
      path = path + "?";

      Object.entries(data.params).forEach(([key, value], index) => {
        if (value) {
          if (index != 0) {
            path = path + "&";
          }
          path = path + key + "=" + value;
        }
      });
    }
    if (!path.startsWith("/")) {
      path = "/" + path;
    }
    // console.log(data)

    // console.log(path)
    // return
    window.history.pushState(null, null, path);
  };

  // changeIndex = (id, windows) => {
  // console.log('iddddddd', id);
  //   if (id) {

  //     setTimeout(() => {
  // console.log('here123');
  //     let windows = JSON.parse(JSON.stringify(this.props.user?.windows))
  // console.log('changewinnnaadddd',windows);
  //     let availableWindows =  Object.values(windows).filter((value) => !value?.minimized)
  //     for (let i = 0; i < Object.values(windows).length; i++) {
  //       const element = Object.values(windows)[i];
  //       element.lastSelected = false
  //       element.zIndex = 13

  //     }
  //     windows[id].lastSelected = true
  //     windows[id].zIndex = 14

  //     this.props.actions.changeWindow(windows)
  //     this.updateURL(windows[id]?.data);
  //     }, 5000);


  //   } else {
  //     this.updateURL({ path: [] });

  //   }
  // }
  changeIndex = (id, windows) => {
    // console.log('hereeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee  dchange', id, windows);
    if (windows) {
      if (id) {

        setTimeout(() => {

          // console.log('here123');
          // let windows = JSON.parse(JSON.stringify(this.props.user?.windows))
          // let availableWindows =  Object.values(windows).filter((value) => !value?.minimized)
          for (let i = 0; i < Object.values(windows).length; i++) {
            const element = Object.values(windows)[i];
            element.lastSelected = false
            element.zIndex = 13

          }
          if (windows[id]) {
            windows[id].lastSelected = true
            windows[id].zIndex = 14

            // console.log("TP1")
            this.props.actions.changeWindow(windows)
            this.updateURL(windows[id]?.data);
          }
        }, 20);
      } else {
        if (Object.values(windows).length > 0 && windows[id]) {

          for (let i = 0; i < Object.values(windows).length; i++) {
            const element = Object.values(windows)[i];
            element.lastSelected = false
            element.zIndex = 13

          }

          if (windows[id]) {

            windows[id].lastSelected = true
            windows[id].zIndex = 14
          }
        }
        setTimeout(() => {
          // console.log("TP2")

          this.props.actions.changeWindow(windows)
          this.updateURL({ path: [] });
        }, 20);

      }
    } else {
      if (id) {
        let windows = JSON.parse(JSON.stringify(this.props.user?.windows))
        let pervSelect = Object.values(windows).filter((value) => value?.lastSelected)
        // console.log('hereeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',pervSelect);
        if (pervSelect.length > 0 && pervSelect[0].id == id) {
          return;
        }


        // console.log('here1231111111111111111111');
        let availableWindows = Object.values(windows).filter((value) => !value?.minimized)
        for (let i = 0; i < Object.values(windows).length; i++) {
          const element = Object.values(windows)[i];
          element.lastSelected = false
          element.zIndex = 13

        }
        windows[id].lastSelected = true
        windows[id].zIndex = 14

        // console.log("TP3")
        this.props.actions.changeWindow(windows)
        this.updateURL(windows[id]?.data);
      } else {
        this.updateURL({ path: [] });

      }

    }



  }

  toggleTower = () => {
    this.tower.toggle();
  };

  takeScreenshot = (windowId, windowContentRef, viewType) => {
    // console.log("takeScreenshot");

    const windows = JSON.parse(JSON.stringify(this.props.user.windows));
    let HighIndexedWindow = Object.values(windows).find(
      (window) => window.zIndex == 14
    );

    html2canvas(windowContentRef).then((canvas) => {
      if (!windows[windowId]) {
        windows[windowId] = {};
      }
      windows[windowId].windowScreen = canvas.toDataURL("image/png");
      windows[windowId].width = window.innerWidth;
      windows[windowId].height = window.innerHeight;
      return;

      this.props.actions.changeWindow(windows)
      // this.setState({ windows }, () => {
      this.setState({ screenshotCount: 1, HighIndexedWindow }, () => { });
      // });
    });
    if (viewType == "Mobile") {
      this.setState({ isDesktop: false, isMobile: true, HighIndexedWindow });
    }
    if (viewType == "Desktop") {
      this.setState({ isDesktop: true, isMobile: false, HighIndexedWindow });
    }
  };

  displayOpenWindows = () => {
    // console.log(this.props.user.windows);
    this.setState({ showWindowsShots: !this.state.showWindowsShots }, () => {
      console.log(this.state.showWindowsShots, "windowshots callback");
    });
  };
  selectWindow = (windowId) => {
    // let windows = JSON.parse(JSON.stringify(this.props.user.windows));
    // console.log(windows[windowId].zIndex);
    // // windows.map.zIndex = 12;
    // windows[windowId].zIndex = 13
    this.setState((prev) => {
      let windowObjects = Object.values(prev.windows);
      for (let wind of windowObjects) {
        wind.zIndex = 12;
      }
      // prev.windows.find((com) => com.id == id).zIndex = 13;
      if (prev.windows[windowId]) {
        prev.windows[windowId].zIndex = 13;
      }
      return {
        windows: prev.windows,
        showWindowsShots: false,
        minimized: false,
      };
    });
    let windows = JSON.parse(JSON.stringify(this.props.user.windows))
    windows[windowId].minimized = false;

    // console.log("TP1")
    this.props.actions.changeWindow(windows)
    // this.setState({ windows });
    // console.log("WINDOW SELECTED");
  };

  changeLanguage = (key, value) => {
    let windows = this.props.user.windows
    for (let i = 0; i < Object.values(windows).length; i++) {
      const element = Object.values(windows)[i];
      element.defaultPosition.x = - element.defaultPosition.x

    }
    // console.log("TP2")

    this.props.actions.changeWindow(windows)
    setTimeout(() => {

      i18n.changeLanguage(value)
      this.closeBox()
    }, 20);

  }

  closeBox = (event) => {
    if (!event || (this.language_select_box && !this.language_select_box.contains(event.target))) {
      document.removeEventListener('mousedown', this.closeBox);
      let box = document.querySelectorAll('.language-select-box')
      if (box) {
        box[0].classList.add('fadeout')
      }

      setTimeout(() => {
        this.setState({ showLanguagesBox: false })
      }, 400);
    }
  }
  showPage = () => {
    if (this.props.pages?.currentPage && this.props.pages?.currentPage.length != 0) {
      return this.props.pages?.currentPage[0]
    }
  }
  toggleLanguagesBox() {
    if (!this.state.showLanguagesBox) {
      document.addEventListener('mousedown', this.closeBox);
      this.setState({ showLanguagesBox: true })
    } else {
      this.closeBox()
    }
  }

  render() {
    const { appSize, dashboardPos, windows } = this.state;
    return (
      <div className="dynamic-dashboard">
        {/* <div
                    // onClick={() => this.addNewWindow()}
                    onClick={() => this.toggleTower()}
                    className="flexcc"
                    style={{
                        position: "absolute",
                        bottom: 10,
                        left: 10,
                        width: 60,
                        height: 60,
                        backgroundColor: "black",
                        color: '#fff',
                        zIndex: 100,
                        borderRadius: 50

                    }}
                >
                    <p>add</p>
                </div> */}
        <div ref={(el) => (this.appRef = el)} style={{ width: "100%", height: "100%" }}>
          <div className="background-img" style={{ backgroundImage: "url('/assets/images/cover10.jpg')", position: "absolute", }}>
            {/* <img className="w-100" src="" alt="" draggable="false" /> */}
            <div className="w-100 flexcb">
              <div className="main-header flexc">
                <img src="/logo-w.svg" style={{ height: 24 }} className="mrd-2" />
                <p className="text-big text-bold">Yonnect</p>

                <p className="text-small mld-3 mt-1">Platform</p>
              </div>
              {/* <div className="flexc mt-3 bg-white p-2 mx-3 br-8">
                {languagesInfo[this.props.settings.language] && (
                  <div className=" " style={{ position: 'relative', }}>
                    <button onClick={() => this.toggleLanguagesBox()} className="flexcc language-but p-0">
                      <img className="" src={languagesInfo[this.props.settings.language].icon} height="20px" alt="" />
                      <span className=" mld-2">{languagesInfo[this.props.settings.language].name}</span>
                    </button>
                    {this.state.showLanguagesBox && (
                      <div ref={el => this.language_select_box = el} className="blur-back language-select-box-desktop fadein">
                        {Object.values(languagesInfo).map((prop, index) => {
                          return (
                            <button key={index} className={" flexc language-select-option " + (index !== 0 ? "mt-3" : '')} onClick={() => this.changeLanguage('language', prop.shortName)}>
                              <img className="mrd-2" src={prop.icon} alt={"language-" + prop.name} />
                              <div>{prop.name}</div>
                            </button>
                          )
                        })}
                      </div>
                    )}
                  </div>
                )}
              </div> */}
            </div>
            <div className="image-info text-end" style={{ transform: this.state.isDesktop ? '' : 'scale(0.8)' }}>
              <p className=" text-smaller">Image by: Unsplash</p>
              <p className=" text-smaller">The beautiful offroad in Europe</p>
            </div>
            <div className="w-100 h-100 flexcc " >
              <div onClick={() => { this.addNewWindow('Search', { addNewWindow: this.addNewWindow }, "center"); }} className='navbar-search mx-4  w-100  br-30 cursor-pointer back-blur' style={{ backgroundColor: 'rgba(255, 255, 255, 0.9)', padding: '10px 10px', top: '200px', position: 'absolute', maxWidth: this.state.isDesktop ? 400 : 250 }} >
                <div className='d-flex flexc'>
                  <img style={{ width: '30px', height: '30px' }} src="/assets/icons/search-black.svg" />
                  <input className="w-100 cursor-pointer " type="text" disabled={true} placeholder={translate(`Search Yonnect and Beyond ...`)} style={{ backgroundColor: 'transparent', pointerEvents: 'none' }} />
                </div>
              </div>
            </div>
            <div className="position-absolute" style={{ right: 10, top: 10, width: "350px" }}>

              {this.props.inbox.list.map((prop) => {
                // console.log('LIST IS', this.props.inbox.list)
                if (prop.type == 'roomInvitation') {
                  // console.log('prop100', prop)
                  if (prop.kind == 'video') {

                    return (

                      <div>
                        {/* {console.log("*******data", prop)} */}
                        <IncomingVideoCall videoCall={true} addNewWindow={this.addNewWindow} data={prop} />
                      </div>
                    )
                  }
                  else if (prop.kind == 'audio') {
                    return (
                      <div className="mt-2" >
                        <IncomingVideoCall videoCall={false} addNewWindow={this.addNewWindow} data={prop} />
                      </div>
                    )
                  }
                }
                else if (prop.type == 'acceptCall' && !prop.used) {
                  let path = ['rooms', prop.applet, prop.frame, prop.room,]
                  let page = { type: "rooms", path };
                  // console.log('e2ye28ye', prop)
                  store.dispatch(actions.updateCall([prop]))
                  this.addNewWindow(page.type, page, "center")
                  let query = ''
                  if (prop.kind == 'video') {
                    query = '?videoCall=true'
                  }
                  else {
                    query = '?videoCall=false'
                  }
                  window.history.pushState(null, null, query)
                  // console.log(window.location.href)
                  // console.log(window.location.pathname)
                }
                else if (prop.type == 'outgoing') {
                  return (
                    <WaitingCall data={prop} />
                  )
                }

              })}
              {this.showPage()}
              {/* {console.log('crrrrrrrpage',this.props.pages?.currentPage)} */}
            </div>
          </div>

          {/* <div ref={(el) => (this.appRef = el)} className="appRef position-absolute h-100 w-100 left-0 top-0" style={{ backgroundColor: 'red' }}>

                    </div> */}

          {/* <DashboardsContainer dashboardPos={dashboardPos} addNewWindow={this.addNewWindow} /> */}
          {this.props.user.loggedin ? (
            <DashboardsContainer ref={(el) => (this.dashboardsContainer = el)} mobile={window.innerWidth <= 520 ? true : false} canScroll={this.state.canScroll} dashboardPos={dashboardPos} addNewWindow={this.addNewWindow} changeWindow={this.changeWindow} />

          ) : (
            <SkeletonDashboardsContainer ref={(el) => (this.dashboardsContainer = el)} canScroll={this.state.canScroll} dashboardPos={dashboardPos} addNewWindow={this.addNewWindow} changeWindow={this.changeWindow} />
          )}
        </div>
        {/* {console.log("this.state.isDesktop", this.state.isDesktop)} */}
        {this.props.user?.loggedin &&
          <>
            {this.state.isDesktop ? (
              <Tower
                ref={(el) => (this.tower = el)}
                addNewWindow={this.addNewWindow}
                changeWindow={this.changeWindow}
                language={this.props.settings?.language}
              />
            ) : (
              <MobileBottomBar HighIndexedWindow={this.state.HighIndexedWindow} />
            )}
          </>}

        {/* {console.log("this.windows", this.props.user.windows)} */}
        {
          Object.values(this.props.user.windows).filter((value) => value?.minimized == true)?.length > 0 ? (
            <>
              <TabFolder changeIndex={this.changeIndex} windows={this.props.user.windows} />
              {/* {console.log("this is window")} */}
            </>
          ) : (
            ""
          )
        }

        {
          !this.state.showWindowsShots
            ? Object.values(this.props.user.windows).map((resizeCom) => {
              const { id, data, width, height, type, defaultPosition, zIndex, info, buttons, lastSelected } = resizeCom;
              return (
                <Window
                  key={id}
                  id={id}
                  data={data}
                  type={type}
                  defaultPosition={defaultPosition}
                  lastSelected={lastSelected}
                  width={width}
                  height={height}
                  zIndex={zIndex}
                  info={info}
                  buttons={buttons}
                  changeIndex={() => this.changeIndex(id)}
                  closeWindow={() => this.closeWindow(id)}
                  minimizeWindow={() => this.minimizeWindow(id)}
                  minimizeAllWindow={this.minimizeAllWindow}
                  changeWindow={this.changeWindow}
                  addNewWindow={this.addNewWindow}
                  setWindowInfo={this.setWindowInfo}
                  takeScreenshot={this.takeScreenshot}
                  setWindowButtons={this.setWindowButtons}
                  showWindowsShots={this.state.showWindowsShots}
                  tabFolder={this.state.tabFolder}
                  setStateProps={this.setStateProps}
                  windows={this.props.user.windows}
                  language={this.props.settings?.language}
                  mainColor={this.state.colors}
                  isDesktop={this.state.isDesktop}
                  isMobile={this.state.isMobile}
                />
              );
            })
            :
            // Object.values(windows).map((resizeCom) => {
            //     const {
            //       id,
            //       data,
            //       width,
            //       height,
            //       type,
            //       defaultPosition,
            //       zIndex,
            //       info,
            //     } = resizeCom;

            // console.log(resizeCom)

            // return (
            <WindowShots
              // data={data}
              // type={type}
              // key={id}
              // id={id}
              minimizeAllWindow={this.minimizeAllWindow}
              addNewWindow={this.addNewWindow}
              closeWindow={this.closeWindow}
              windows={Object.values(this.props.user.windows)}
              selectWindow={this.selectWindow}
              showWindowsShots={this.state.showWindowsShots}
            />
        }
        {
          window.innerWidth <= 520 ? (
            <div className="window__bottombar flexcb px-4">
              <div onClick={() => { this.minimizeAllWindow(); this.setState({ showWindowsShots: false }) }}>
                <img className="flexcc" src="/assets/icons/home.svg" width={40} alt="" />
              </div>

              {/* <div> */}
              {this.props.user?.loggedin ? (
                <Tower mobile={true} ref={(el) => (this.tower = el)} addNewWindow={this.addNewWindow} changeWindow={this.changeWindow} language={this.props.settings?.language} />
              ) : (
                <MobileBottomBar HighIndexedWindow={this.state.HighIndexedWindow} />
              )}
              {/* </div> */}

              <div onClick={(e) => this.displayOpenWindows()} className="">
                {/* {Object.values(this.props.user.windows).length} */}
                <img className="flexcc" src="/assets/icons/tabs.svg" width={40} alt="" />
              </div>
            </div>
          ) : null
        }

        {
          this.state.isLoadingUserInfo && (
            <div className="position-fixed h-100 w-100 flexcc" style={{ backgroundColor: "#00000050", zIndex: 99999999999999, }}>
              <Loader type={"ThreeDots"} color={"#fff"} height={50} width={50} />
            </div>
          )
        }

        {
          this.props.settings.socketStatus == false && (
            <div className="px-3 py-3 white d-flex fadein" style={{ maxWidth: 230, position: "fixed", bottom: 20, right: 20, zIndex: 100, background: "linear-gradient(to right bottom, rgb(240,150,20), rgb(254,190,1))", borderRadius: "20px 8px 8px 8px", boxShadow: "0px 0px 50px #10101030", }}>
              <div className="pt-1">
                <img className="invert" src="https://cdn-icons-png.flaticon.com/512/1008/1008969.png" style={{ height: "30px" }} />
              </div>
              <div className="mld-4">
                <p className="text-small text-bold">
                  {translate("Connection Failed")}
                </p>
                <p className="text-smaller text-semibold">
                  {translate("You are not connected to the server")}
                </p>
                <p className="text-smaller text-semibold">
                  {translate("Retry in 20 seconds ...")}
                </p>
              </div>
            </div>
          )
        }




        {this.state.notLoggedIn && (
          <div className="px-3 py-3 white d-flex fadein" style={{ maxWidth: 230, position: "fixed", bottom: 20, right: 20, zIndex: 101, background: "linear-gradient(to right bottom, #ee5050, #ff4040", borderRadius: "20px 8px 8px 8px", boxShadow: "0px 0px 50px #10101030", }}>
            <div className="" style={{ position: 'absolute', top: 15, right: 10, }}>
              <button className="flexcc br-20" style={{ backgroundColor: '#fff', height: 20, width: 20 }}>
                <img className="" src="/assets/icons/minimize-red.svg" width="10px" />
              </button>
            </div>
            <div className="mld-0">
              <p className="text-small text-bold mb-2">
                {translate("Not logged in")}
              </p>
              <p className="text-smaller text-semibold ">
                {translate("For making be use of Yonnect, it's better to login to the system.")}
              </p>
              {/* <p className="text-smaller text-semibold">
                {translate("Retry in 20 seconds ...")}
              </p> */}
              <div className="mt-2" style={{ pointerEvents: 'all' }}>
                <ButtonAnimated
                  iconwidth='30px'
                  onClick={() => this.addNewWindow("authentication", {}, "center")}
                  title={translate("Log in / Sign up")}
                  icon='/assets/icons/arrow-right-red.svg'
                  textColor={'#ee5050'}
                  // invert={true}
                  bg={'linear-gradient(90deg, rgb(255, 255, 255), rgb(255, 255, 255))'}
                />
              </div>
            </div>

            <div>

            </div>
          </div>
        )
        }
      </div >
    );
  }
}
// const mapStateToProps = state => {
//     return {
//         lang: state.settings.language
//     }
// }
// export default connect(mapStateToProps)(Desktop);

const mapStateToProps = (state) => ({
  settings: state.settings,
  user: state.user,
  resource: state.resource,
  notif: state.notif,
  pages: state.pages,
  inbox: state.inbox,
});
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(Desktop);